import { createRoutine, promisifyRoutine } from 'redux-saga-routines';

export const getWebhooks = createRoutine('getWebhooks');
export const getWebhooksPromiseCreator = promisifyRoutine(getWebhooks);

export const getWebhookById = createRoutine('getWebhookById');
export const getWebhookByIdPromiseCreator = promisifyRoutine(getWebhookById);

export const createWebhook = createRoutine('createWebhook');
export const createWebhookPromiseCreator = promisifyRoutine(createWebhook);

export const updateWebhook = createRoutine('updateWebhook');
export const updateWebhookPromiseCreator = promisifyRoutine(updateWebhook);

export const deleteWebhook = createRoutine('deleteWebhook');
export const deleteWebhookPromiseCreator = promisifyRoutine(deleteWebhook);

export const testWebhook = createRoutine('testWebhook');
export const testWebhookPromiseCreator = promisifyRoutine(testWebhook);
